(function(){
  if(window.__dmxBuyBound) return; window.__dmxBuyBound = true;
  /* Delegated: survives theme-editor section re-renders, which don't re-run inline scripts. */
  /* .nhb-bundles is the real pack ladder rendered by the pelvior_packs block.
     The empty #dmx-buybox anchor collapses to document position 0, so it is only
     a last resort, never the primary target. */
  var SEL = ['.nhb-bundles','.nhb-card','.product-form__quantity','quantity-input',
             '.quantity','variant-picker','.product-form__variants',
             '.product-form__buttons','product-form','.product-form','#dmx-buybox'];
  function target(){
    var main = document.querySelector('#MainProduct, .shop-product-section, [id^="shopify-section"][id*="__main"]') || document;
    for (var i=0;i<SEL.length;i++){
      var el = main.querySelector(SEL[i]);
      if (el && el.getBoundingClientRect().height > 0) return el;
    }
    return main === document ? null : main;
  }
  document.addEventListener('click', function(e){
    /* opt-in hooks: our own CTAs, plus anything the merchant wires up in a
       custom block (give it data-dmx-buy, or link it to #dmx-buybox). */
    var b = e.target.closest && e.target.closest('[data-dmx-buy],a[href$="#dmx-buybox"],[data-dmx-scroll]');
    if(!b) return;
    e.preventDefault();
    var t = target(); if(!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    /* 'auto' not 'smooth': some themes disable smooth scrolling and the jump then fails */
    window.scrollTo({top: y, behavior: 'auto'});
    var f = t.querySelector('select,input[type="number"],button') || t;
    if (f && f.focus) { try { f.focus({preventScroll:true}); } catch(err){ } }
  });
})();
